'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.injectToContainer = exports.verifyUserWithCode = exports.requestVerification = exports.resetPassword = exports.forgotPassword = exports._verifyUserWithCode = exports._requestVerification = exports._resetPassword = exports._forgotPassword = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

/**
 * Send a forgot password email to the email address.
 *
 * @injectTo {AuthContainer} as forgotPassword
 * @param  {String} email - target email address
 * @return {Promise} promise
 *
 * @example
 * skygear.auth.forgotPassword(email).then(...);
 */
var _forgotPassword = exports._forgotPassword = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(email) {
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', this.container.lambda('user:forgot-password', {
              email: email
            }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function _forgotPassword(_x) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Reset password with a code generated by the server. The code can be
 * retrieved by forgotPassword.
 *
 * @injectTo {AuthContainer} as resetPassword
 * @param  {String} userID - target user ID
 * @param  {String} code - code generated by server
 * @param  {Number} expireAt - utc timestamp
 * @param  {String} newPassword - new password of the user
 * @return {Promise} promise
 *
 * @example
 * skygear.auth.resetPassword(userID, code, expireAt, newPassword).then(...);
 */


var _resetPassword = exports._resetPassword = function () {
  var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(userID, code, expireAt, newPassword) {
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', this.container.lambda('user:reset-password', {
              user_id: userID, /* eslint camelcase: 0 */
              code: code, /* eslint camelcase: 0 */
              expire_at: expireAt, /* eslint camelcase: 0 */
              new_password: newPassword
            }));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function _resetPassword(_x2, _x3, _x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * Request to verify user data.
 *
 * @injectTo {AuthContainer} as requestVerification
 * @param  {String} recordKey - record key containing user data to be verified
 * @return {Promise} promise
 *
 * @example
 * skygear.auth.requestVerification("email").then(...);
 */


var _requestVerification = exports._requestVerification = function () {
  var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(recordKey) {
    return _regenerator2.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt('return', this.container.lambda('user:verify_request', {
              record_key: recordKey /* eslint camelcase: 0 */
            }));

          case 1:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function _requestVerification(_x6) {
    return _ref3.apply(this, arguments);
  };
}();

/**
 * Verify user by specifying verification code sent by server.
 *
 * @injectTo {AuthContainer} as verifyUserWithCode
 * @param  {String} code - code received from server
 * @return {Promise} promise
 *
 * @example
 * skygear.auth.verifyUserWithCode("123456").then(...);
 */


var _verifyUserWithCode = exports._verifyUserWithCode = function () {
  var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(code) {
    return _regenerator2.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return this.container.lambda('user:verify_code', {
              code: code
            });

          case 2:
            return _context4.abrupt('return', this.whoami());

          case 3:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function _verifyUserWithCode(_x7) {
    return _ref4.apply(this, arguments);
  };
}();

/**
 * @ignore
 */


var _skygearCore = require('skygear-core');

var _skygearCore2 = _interopRequireDefault(_skygearCore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var forgotPassword = exports.forgotPassword = _forgotPassword.bind(_skygearCore2.default.auth);

/**
 * @ignore
 */
var resetPassword = exports.resetPassword = _resetPassword.bind(_skygearCore2.default.auth);

/**
 * @ignore
 */
var requestVerification = exports.requestVerification = _requestVerification.bind(_skygearCore2.default.auth);

/**
 * @ignore
 */
var verifyUserWithCode = exports.verifyUserWithCode = _verifyUserWithCode.bind(_skygearCore2.default.auth);

/**
 * @private
 */
var injectToContainer = exports.injectToContainer = function injectToContainer() {
  var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _skygearCore2.default;

  var authContainerPrototype = container.auth.constructor.prototype;
  authContainerPrototype.forgotPassword = _forgotPassword;
  authContainerPrototype.resetPassword = _resetPassword;
  authContainerPrototype.requestVerification = _requestVerification;
  authContainerPrototype.verifyUserWithCode = _verifyUserWithCode;
};